import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
// Import Bootstrap an BootstrapVue CSS files (order is important)


import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import { LMap, LTileLayer, LMarker, LPolygon ,LPolyline, LControl,LControlLayers,LCircle,LCircleMarker,LTooltip,LIcon  ,LGeoJson,LPopup,LLayerGroup,LControlZoom,LControlScale,LWMSTileLayer,LImageOverlay } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';

Vue.component('l-map', LMap);
Vue.component('l-tile-layer', LTileLayer);
Vue.component('l-marker', LMarker);
Vue.component('l-polyline', LPolyline);
Vue.component('l-control', LControl);
Vue.component('l-control-layers', LControlLayers);
Vue.component('l-polygon', LPolygon);LCircle
Vue.component('l-circle', LCircle);
Vue.component('l-tooltip', LTooltip);
Vue.component('l-geo-json', LGeoJson);
Vue.component('l-popup', LPopup);
Vue.component('l-layer-group', LLayerGroup);
Vue.component('l-control-zoom', LControlZoom);
Vue.component('l-control-scale', LControlScale);
Vue.component('l-wms-tile-layer', LWMSTileLayer);
Vue.component('l-icon', LIcon);
Vue.component('l-circle-marker', LCircleMarker);
Vue.component('l-image-overlay', LImageOverlay);

delete L.Icon.Default.prototype._getIconUrl;
import L from 'leaflet';


L.Icon.Default.mergeOptions({
   iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
   iconUrl: require('leaflet/dist/images/marker-icon.png'),
   shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});


import VueHighcharts from 'vue2-highcharts'

Vue.component('vue-highcharts',VueHighcharts);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
